define((require) => {
    "use strict";

    var SceneNavigatorWidgetModel = require("shared/ui/experience/widgets/sceneNavigatorWidget/SceneNavigatorWidgetModel");

    /**
     * @class {SceneNavigatorWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return SceneNavigatorWidgetModel.mixin("SceneNavigatorWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string} The self description
         */
        _getSelfDescription: function() {
            return `Scene Selector`;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/sceneNavigatorWidget/SceneNavigatorWidgetModelEditorMixin.js